import money from '@/core/charts/components/money'
import tooltip from '@/core/charts/components/tooltip-standard'
import formatter from '@/core/charts/helper/formatter'
import chartColors from '@/core/charts/helper/chartColors'

export default {
  // chartType: 'Bar',
  showLegend: false,
  showSmallLegend: true,
  chartOpts: getOptions(),

  chartData: (widget, data) => getChartData(data),
  chartInfo: (widget, data) => getChartInfo(data, 0),
  drillDown: (ctx, value, index) => executeDrillDown(ctx, value, index),
  drillDownReturn: (ctx) => reverseDrillDown(ctx),

  components: {
    labelValue: money,
    tooltip
  }
}

function getOptions() {
  let baseCustSet = {
    chartGroupValue: 'Category',
    containterStyle: '',
    hasDrillDown: true,
    recalculateGridMax: true,
    dynamicHeight: true,
    showTotal: true,
    multipleSeries: true,
    tooltip: {
      tooltipType: 'standard',
      width: '200px'
    }
  }
  let baseOpts = {
    customSettings: baseCustSet,
    lineSmooth: true,
    stackBars: true,
    horizontalBars: true,
    seriesBarDistance: 18,
    labelInterpolationFnc: function(value) { return value[0] },
    showPoint: false,
    targetLine: {
      value: 0,
      class: 'ct-target-line'
    },
    fullWidth: false,
    axisY: {
      position: 'start',
      labelOffset: { x: 2, y: 1 },
      scaleMinSpace: 15,
      showGrid: true,
      showLabel: true,
      offset: 130,
      labelInterpolationFnc: function(value) { return value }
    },
    chartPadding: { top: 5, right: 25, bottom: 5, left: 5 }
  }
  return baseOpts
}

function getChartInfo(dataIn, pos) {
  let result = []
  dataIn.forEach(elem => {
    let gdPos = result.findIndex(k => k[0] === elem[pos])
    if (gdPos === -1) result.push(elem[pos])
  })
  return result.map(k => k[0])
}

function getChartData(data) {
  let labelsGrouped = []

  let totalSpend = 0
  data.forEach(elem => {
    if (elem[0] !== '') {
      var gdPos = labelsGrouped.findIndex(k => k[0] === elem[0])
      if (gdPos === -1) {
        labelsGrouped.push([elem[0], elem[2], [0, 0, 0]])
        totalSpend += elem[2]
        var labelPos = labelsGrouped.findIndex(k => k[0] === elem[0])
        if (elem[3] === 'Preferred') labelsGrouped[labelPos][2][0] = elem[2]
        else if (elem[3] === 'Approved') labelsGrouped[labelPos][2][1] = elem[2]
        else labelsGrouped[labelPos][2][2] = elem[2]
      } else {
        labelsGrouped[gdPos][1] += elem[2]
        totalSpend += elem[2]
        if (elem[3] === 'Preferred') labelsGrouped[gdPos][2][0] += elem[2]
        else if (elem[3] === 'Approved') labelsGrouped[gdPos][2][1] += elem[2]
        else labelsGrouped[gdPos][2][2] += elem[2]
      }
    }
  })
  let sortedData = labelsGrouped.slice(0)
  sortedData.sort(function (a, b) { return a[1] - b[1] })
  let totals = sortedData.map(k => k[1])
  let maxValue = formatter.getArrayMaxValue(totals)
  let minValue = formatter.getArrayMinValue(totals)
  let avgTot = formatter.getArrayAverage(totals)
  let seriesGrouped = sortedData.map(k => k[2])
  totals = sortedData.map(k => formatter.thousandsFormatter(k[1]))
  return {
    total: totalSpend.toFixed(2),
    labels: sortedData.map(k => k[0]),
    series: [
      {
        type: 'Bar',
        stackBars: true,
        maxValue: maxValue,
        minValue: minValue,
        barSpace: 36,
        minHeight: 90,
        vLines: [
          { name: 'Avg Spend', value: avgTot, color: chartColors.purple, class: 'ct-value-line' }
        ],
        ignoreForCharts: false,
        data: [
          {
            name: 'Preferred',
            value: seriesGrouped.map(k => k[0].toFixed(2)),
            color: chartColors.blueLight,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Approved',
            value: seriesGrouped.map(k => k[1].toFixed(2)),
            color: chartColors.green,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Other',
            value: seriesGrouped.map(k => k[2].toFixed(2)),
            color: chartColors.purple,
            width: '25px',
            ignoreLabel: false,
            metadata: { barLabels: totals }
          }
        ]
      }
    ],
    tooltipData: {
      helpText: 'Click on the bar to show subcategory spend details.',
      metadata: tooltipMetadata,
      data: [
        sortedData.map(t => t[0]),
        seriesGrouped.map(k => k[0].toFixed(2)),
        seriesGrouped.map(k => k[1].toFixed(2)),
        seriesGrouped.map(k => k[2].toFixed(2)),
        seriesGrouped.map(k => (k[0] + k[1] + k[2]).toFixed(2)),
        avgTot,
        seriesGrouped.map(k => ((k[0] + k[1] + k[2]) * 100 / totalSpend).toFixed(2))
      ]
    }
  }
}

function getChartDataDrilled(dataIn, value) {
  if (dataIn.length === 0) return {labels: null, series: []}
  let labelsGrouped = []
  dataIn.forEach(subcat => {
    if (subcat[0] === value) {
      let label = subcat[1]
      if (label === null || label === '') label = 'No Subcategory'
      let pos = labelsGrouped.findIndex(k => k[0] === label)
      if (pos === -1) {
        labelsGrouped.push([label, subcat[2], subcat[5], subcat[4]])
      } else {
        labelsGrouped[pos][1] += subcat[2]
        labelsGrouped[pos][2] += subcat[5]
        labelsGrouped[pos][3] += subcat[4]
      }
    }
  })
  let sortedData = labelsGrouped.slice(0)
  sortedData.sort(function (a, b) { return a[1] - b[1] })
  let firstBar = sortedData.map(k => k[1].toFixed(2))
  let secondBar = sortedData.map(k => (k[2] / k[3]).toFixed(2))
  let firstBarAvg = formatter.getArrayAverage(firstBar)
  let sec = sortedData.reduce((r, a) => a.map((b, i) => (r[i] || 0) + b), [])
  let secondBarAvg = (sec[2] / sec[3]).toFixed(2)
  let max1 = formatter.getArrayMaxValue(firstBar)
  let min1 = formatter.getArrayMinValue(firstBar)
  let max2 = formatter.getArrayMaxValue(secondBar)
  let min2 = formatter.getArrayMinValue(secondBar)
  let xMod = getXModifier(max1, max2)
  return {
    labels: sortedData.map(k => k[0]),
    series: [
      {
        type: 'Bar',
        hasTooltipData: true,
        stackBars: false,
        maxValue: max1,
        minValue: min1 < (min2 * xMod) ? min1 : (min2 * xMod),
        barSpace: 50,
        minHeight: 70,
        ignoreForCharts: false,
        vLines: [
          { name: 'Avg Spend', value: firstBarAvg, color: chartColors.purple, class: 'ct-value-line' },
          { name: 'Overall Avg Price Per Unit', value: (secondBarAvg * xMod), color: chartColors.green, class: 'ct-value-line' }
        ],
        backgroundChart: false,
        data: [
          {
            name: 'Total Spend',
            value: firstBar,
            ignoreLabel: false,
            color: chartColors.purple,
            width: '13px',
            metadata: { barLabels: firstBar.map(k => formatter.thousandsFormatter(k)) }
          },
          {
            name: 'Avg Price Per Unit',
            value: secondBar,
            ignoreLabel: true,
            xModifier: xMod,
            color: chartColors.green,
            width: '13px'
          }
        ]
      }
    ],
    tooltipData: {
      metadata: tooltipMedatadaDrilled,
      data: [
        sortedData.map(k => k[0]),
        firstBar,
        secondBar,
        firstBarAvg,
        secondBarAvg
      ]
    }
  }
}

function executeDrillDown(ctx, value) {
  let catName = value
  let fullData = ctx.rawData.filter(row => ~row.indexOf(catName))
  let newChartData = getChartDataDrilled(fullData, value)
  ctx.chartData = newChartData
  ctx.chartInfo = newChartData.labels
  ctx.chartComponent.chartOpts.stackBars = false
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = false
  ctx.chartComponent.chartOpts.customSettings.tooltip = {
    width: '235px',
    topOffset: -10,
    leftOffset: 50
  }
  ctx.$emit('childRedraw')
}

function reverseDrillDown(ctx) {
  ctx.chartComponent.chartOpts = getOptions()
  ctx.$emit('childRedraw')
}

function getXModifier(c1, c2) {
  let diff = c1 / c2
  let result = diff / 2
  return result
}

const tooltipMetadata = [
  {
    label: '',
    type: 'title',
    format: ''
  },
  {
    label: 'Preferred',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Approved',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Other',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Total Spend',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Avg Spend',
    type: 'secondary',
    format: 'currency'
  },
  {
    label: '% of Total',
    type: 'secondary',
    format: 'percentage'
  }
]
const tooltipMedatadaDrilled = [
  {
    label: '',
    type: 'title',
    format: ''
  },
  {
    label: 'Total Spend',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Avg Price Per Unit',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Avg Spend',
    type: 'secondary',
    format: 'currency'
  },
  {
    label: 'Overall Avg Price Per Unit',
    type: 'secondary',
    format: 'currency'
  }
]



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/CategorySpend/chart.js